import ApiService from './ApiService';
import { ResearchDashboardDto } from '../../research-dashboard/interfaces/ResearchDashboardDto';
import { ApiPath } from './enums/ApiPath';

export class ResearchApiService {
  static getDashboard(): Promise<ResearchDashboardDto> {
    return ApiService.get<ResearchDashboardDto>(ApiPath.ResearchDashboard);
  }
}
